import { render } from "./ChiTietLenh.vue?vue&type=template&id=235ebb8d&scoped=true"
import script from "./ChiTietLenh.vue?vue&type=script&lang=js"
export * from "./ChiTietLenh.vue?vue&type=script&lang=js"

import "./ChiTietLenh.vue?vue&type=style&index=0&id=235ebb8d&scoped=true&lang=css"
import "./ChiTietLenh.vue?vue&type=style&index=1&id=235ebb8d&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235ebb8d"]])

export default __exports__